import * as actionTypes from "../Actions/actionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const disconnectWalletReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_DISCONNECT_WALLET_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case actionTypes.SET_DISCONNECT_WALLET_SUCCESS:
      return { ...state, loading: false, success: true, error: null };

    case actionTypes.SET_DISCONNECT_WALLET_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default disconnectWalletReducer;
